import ScannerError from '../types/abstract/ScannerError';

export default class CameraRequiredError extends ScannerError {
  constructor() {
    super('This application requires a camera, please use an alternative device', {});
  }
}
